import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, Link, Image, Text } from '@/ui'
import { updateFinancialProfile } from '@/actions/financialProfileActions'
import { useReselector } from '@/utils/sharedHooks'
import { getFinancialProfile } from '@/selectors/user.selectors'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import {
  dateWithoutTimestamp,
  useCompleteQTEActionItemIfNeeded,
} from '@/features/taxes/quarterly-tax-estimates/service'
import { TypographyStyles } from '@/styles'

export const FinishTaxProfile = () => {
  const fp = useReselector(getFinancialProfile)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(
      updateFinancialProfile(fp?.id, {
        taxProfileLastReviewed: dateWithoutTimestamp().format(
          DATE_FORMATS.TIMESTAMP
        ),
      })
    )
  }, [dispatch, fp?.id])

  useCompleteQTEActionItemIfNeeded()

  return (
    <div className="flex flex-col items-center gap-4 max-w-3xl mx-auto">
      <Image
        src="https://heard-images.s3.amazonaws.com/assets/deductions/clipboard.svg"
        alt="Clipboard"
        className="w-[120px] h-[120px]"
      />

      <Text
        className="w-full text-center"
        variant={TypographyStyles.DISPLAY_SM}
      >
        Thanks for updating your tax information!
      </Text>

      <Button variant="secondary" onClick={() => navigate('/taxes/quarterly')}>
        Return to Quarterly Taxes
      </Button>

      <Link href="/practice/profile/editTax" newPage={false}>
        Edit Tax Information
      </Link>
    </div>
  )
}
